module.exports = __webpack_public_path__ + "img/img4.822193a4.png";